import React, { useEffect, useState } from "react";
import { Grid, TextField, Button, Typography } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

function SecurityQuestions() {
  const auth = sessionStorage.getItem("user");

  const [securityQAs, setSecurityQAs] = useState([]);

  const ReadData = async () => {
    try {
      let values = { tab: 9 };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(`${baseUrl}/defaultBusinesSettingData`, values, config);
      setSecurityQAs(result.data.result || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    ReadData();
  }, []);

  return (
    <form>
      <Grid container spacing={2}>
        {securityQAs.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" sx={{ mt: 1 }}>
                {item.question}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
              label="Answer"
                fullWidth
                value={item.answer}
                variant="outlined"
                size="small"
                InputProps={{ readOnly: true }}
                disabled
              />
            </Grid>
          </React.Fragment>
        ))}
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            color="success"
            sx={{ float: "right" }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

export default SecurityQuestions;
